import React from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';

import { userHasFeature } from '../../../../helpers/Features';

import AdminGroups from '../../../../containers/Admin/Groups';
import AdminGroupEdit from '../../../../containers/Admin/GroupEdit';
import UpgradeBoard from '../../../UpgradeBoard';

const SettingsTeamsContent = (props) => {
  const { activeSubTab } = props;
  const { groupId } = useParams();

  if (!userHasFeature('custom-teams')) return <UpgradeBoard feature="custom-teams" />;

  if (!activeSubTab && !groupId) return <AdminGroups />;

  if (activeSubTab === 'add' || groupId) return <AdminGroupEdit />;

  return null;
};

SettingsTeamsContent.propTypes = {
  activeSubTab: PropTypes.string,
};

SettingsTeamsContent.defaultProps = {
  activeSubTab: null,
};

export default SettingsTeamsContent;
